import { useState, useCallback } from 'react';

/**
 * Custom hook to manage WebSocket connection state
 * Provides state management for WebSocket lifecycle independent of network status
 * 
 * States:
 * - 'idle': No WebSocket connection (not recording)
 * - 'connecting': WebSocket is being established
 * - 'connected': WebSocket successfully connected and active
 * - 'disconnected': WebSocket closed (intentional or error, not recording)
 * - 'reconnecting': Attempting to reconnect WebSocket after unexpected disconnect
 * 
 * @returns {Object} WebSocket status information
 * @returns {string} wsState - Current WebSocket state
 * @returns {function} setWsState - Function to update WebSocket state
 * @returns {function} resetWsState - Function to reset to idle state
 */
export const useWebSocketStatus = () => {
  const [wsState, setWsState] = useState('idle');
  
  const resetWsState = useCallback(() => {
    setWsState('idle');
  }, []);
  
  return { wsState, setWsState, resetWsState };
};
